const translations = {
    mainNav: {
        language: "Lingua",
        shoppingBasket: "Carrello",
        login: "Login",
        logout: "Esci",
        register: "Registrarsi",
        user: "Utente",
        bookings: "Prenotazioni",
        transfers: "Trasferimenti",
        profile: "Profilo",
    },
    footer: {
        legalNotice: "Avviso legale",
        privacyPolicy: "Politica sulla riservatezza",
        contractTerms: "Politica di assunzione",
        cookiesPolicy: "Politica sui cookie",
        complaintChannel: "Canale di Segnalazione"
    },
    bookingForm: {
        event: "Evento",
        selectEventToBook: "Seleziona l'evento da prenotare",
        checkIn: "Dal",
        checkOut: "Al",
        guest: "persona",
        guests: "persone",
        addDate: "Add date",
        addGuest: "Add",
        numberOfRooms: "Camere",
        adults: "Adulti",
        children: "Bambini",
        roomNumber: "Camera {{number}}"
    },
    bookingMeForm: {
        confirmationNumber: "Numero",
        bookingStatus: "Stato",
        paymentStatus: "Stato del pagamento",
        event: "Evento",
        city: "Città",
        hotel: "Albergo",
        year: "Anno",
        name: "Stato della prenotazione",
        searchByBookingStatus: "Cerca per stato della prenotazione",
        searchByPaymentStatus: "Cerca per stato del pagamento",
        searchByConfirmationNumber: "Cerca per numero di conferma",
        searchByEvent: "Cerca per evento",
        searchByCity: "Cerca per città",
        searchByHotel: "Cerca per albergo",
        searchByYear: "Cerca per anno",
        confirmed: "Confermata",
        pending: "In attesa",
        canceled: "Annullata",
        paid: "Pagata",
        notPaid: "Non pagata",
        refunded: "Rimborsata",
    },
    cityEventMainCard: {
        hotels: "Alberghi",
        transferService: "Servizio di transferimento",
        from: "Dal",
        to: "Al",
    },
    hotelMapCard: {
        minNightsRequired: "Questo hotel richiede un minimo di {{nights}} notti",
        discountCode: "{{code}}",
        forNight: "a partire da <PriceFormatter>{{price}}</PriceFormatter> per notte",
        externalRedirectTitle: "Stai per lasciare il nostro sito web",
        externalRedirectMessage: "Verrai reindirizzato al sito di Booking.com per continuare la tua prenotazione. Vuoi continuare?",
        cancel: "Annulla",
        ok: "Vai a Booking.com",
    },
    hotelDetail: {
        amenities: "Punti salienti della proprietà",
        amenitiesDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        viewMoreAmenities: "view more amenities",
        informationAndExtras: "Informazioni ed extras",
        informationAndExtrasDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        location: "Location",
        cancellationPolicy: "Politica di cancellazione",
        modifyDates: "Modifica le date",
        addRoom: "Aggiundere camera",
        from: "From:",
        to: "To:",
        capacity: "Capacità:",
        total: "Prezzo",
        roomAdded: "Added room",
        roomNotAvailable: "Camera non disponibile",
        roomNotAvailableAt: "Non c'è disponibilità per queste notti: {{dates}}",
        roomAvailableWithOverbooking: "Camera con giorni in attesa di conferma",
        roomAvailableWithOverbookingAt: "Prenotazione con giorni in attesa di conferma. Il nostro team controllerà la disponibilità per queste notti e ti ricontatterà il prima possibile: {{dates}}",
        roomAvailableWithOverbookingOnRequest: "SU RICHIESTA",
        roomAvailableWithOverbookingConfirm: "Fare clic su conferma per continuare",
        hotelNotAvailable: "Non puoi aggiungere camere di hotel diversi",
        addRoomErrorTitle: "Si è verificato un errore.",
        addRoomError: "Si è verificato un errore e la camera non può essere aggiunta al carrello",
        goToCheckout: "Vai alla cassa",
        details: "Dettagli",
        quantity: "Quantità",
    },
    common: {
        actions: {
            add: "Aggiungi",
            accept: "Accetta",
            cancel: "Annulla",
            edit: "Modifica",
            delete: "Elimina",
            submit: "Invia",
            save: "Salva",
            upload_file: "Carica file",
            search: "Cerca",
            show_more_filters: "Mostra più filtri",
            hide_more_filters: "Nascondi altri filtri",
            clear: "Pulito",
            back: "Ritorno",
            goHome: "Vai a casa",
            copy: "Copia",
            confirm: "Conferma",
            select: "Seleziona",
            selected: "Selezionato",
            send: "Invia",
            loading: "Caricamento in corso",
            close: "Chiudi",
            loginOrRegisterMsg: "<LoginLink>Accedi</LoginLink> o <RegisterLink>registrati</RegisterLink> per salvare la tua prenotazione e accedervi in qualsiasi momento!",
            next: "Avanti",
            previous: "Indietro",
            sending: "Invio in corso",
            complete: "Completa",
            unSelect: "Cancella selezione",
        },
        labels: {
            required_field: "Campo obbligatorio",
            filters: "Filtri",
            none: "Nessuno",
            all: "Tutti",
            creation_date: "Data di creazione",
            error: "Errore",
            administration: "Amministrazione",
            actions: "Azioni",
            selected_items: "{{count}} elementi selezionati",
            per_page: "Per pagina",
            sort_by: "Ordina per",
            total: "Totale",
            language: "Lingua",
            iAcceptThe: "Ho letto e accetto la <AcceptButton>{{terms}}</AcceptButton>",
        },
        feedback: {
            saved_data: "Dati salvati con successo",
            no_data: "Nessun dato",
            form_not_valid: "Ci sono errori nel modulo",
            field_required: "Il campo è obbligatorio",
            field_min: "Il valore del campo non può essere inferiore a {{min}}",
            field_max: "Il valore del campo non può essere maggiore di {{max}}",
            field_min_length:
                "La lunghezza del campo non può essere inferiore a {{length}}",
            field_max_length:
                "La lunghezza del campo non può essere maggiore di {{length}}",
            field_valid_email: "{{value}} non è un'email valida",
            field_valid_iban: "{{value}} non è un IBAN corretto",
            unexpected_error: "Si è verificato un errore imprevisto",
            field_required_terms: "È necessario leggere e accettare l'{{terms}}",
             time_cannot_be_in_past: "L'ora non può essere minore dell'ora attuale",
        },
        enum: {
            transportType: {
                plane: "Aereo",
                train: "Treno",
                bus: "Autobus",
                other: "Altro",
            },
            transferDirection: {
                oneWay: "Solo andata",
                comeBack: "Solo ritorno",
                both: "Andata e ritorno",
            },
            transferVehicle: {
                sedan: "Sedan",
                van: "Van",
                businessSedan: "Business Sedan",
                businessVan: "Business Van",
            },
            transferStatus: {
                pending: "In attesa",
                transferCreated: "Trasferimento Creato",
                updated: "Aggiornato",
                cancelled: "Annullato",
                confirmed: "Confermato",
                requestInfo: "Richiesta Informazioni",
                formSent: "Modulo Inviato",
            },
        }
    },
    auth: {
        actions: {
            sign_in: "Accedi",
            logout: "Esci",
            reset_password: "Reimposta password",
        },
        fields: {
            email: "e-mail",
            password: "Password",
            new_password: "Nuova password",
            confirm_new_password: "Conferma Nuova password",
        },
        labels: {
            forgot_password: "Hai dimenticato la password?",
            forgot_password_subheading:
                "Inserisci la tua email per reimpostare la password",
        },
        feedback: {
            unauthorized: "La sessione non è valida",
            passwords_does_not_match: "Le password non corrispondono",
        },
    },

    error404: {
        labels: {
            heading:
                "Spiacenti, non riusciamo a trovare la pagina che stai cercando.",
            subheading:
                "Potrebbe esserci un errore di ortografia nell'URL che hai inserito o la pagina che stai cercando non esiste più.",
        },
    },

    home: {
        title: "Inizio",
    },
    cart: {
        title: "Carrello",
    },
    checkout: {
        title: "Dettagli della prenotazione",
        continueShopping: "Continua a fare acquisti",
        noItemsInTheCart: "Non ci sono articoli nel carrello",
        total: "Totale",
        total_without_taxes: "Totale senza tasse",
        total_taxes: "Tasse",
        total_basket: "Totale della prenotazione",
        total_pending: "Totale in attesa",
        discount: "Sconto",
        total_to_pay: "Totale da pagare",
        total_payed: "Totale pagato",
        confirm_booking: "Conferma prenotazione",
        clear_basket: "Cancella cestino",
        total_nights: "Notti",
        nights: "notti",
        night_of: "Notte di",
        from: "Da",
        to: "A",
        delete: "Elimina",
        book_price_detail: "Dettagli prezzo libro",
        errorWithPaymentItWillBeRefund: "Si è verificato un errore nel processo di pagamento. Se il pagamento è stato effettuato, verrà restituito per intero nel più breve tempo possibile. Contatta un amministratore se l'errore continua a verificarsi.",
        status: {
            name: "Stato",
            pending: "In attesa",
            confirmed: "Confermato",
            canceled: "Annullato",
        },
        paymentStatus: {
            unpaid: "Non pagato",
            payment_requested: "Pagamento richiesto",
            payment_scheduled: "Pagamento programmato",
            paid: "Pagato",
            refunded: "Rimborsato",
        },
    },
    booking: {
        title: "Conferma e pagamento",
        noBookings: "Non hai ancora nessuna prenotazione.",
        personalInformation: "Informazioni personali",
        paymentInformation: "Informazioni di pagamento",
        invoiceInformation: "Informazioni sulla fattura",
        name: "Nome",
        surname: "Cognomi",
        email: "Email",
        telephone: "Telefono",
        invalidTelephone: "Per favore inserisci UN numero di telefono valido",
        roomsWithOverbookingDisclaimer: "Quando si finaliza la prenotazione, Le contattaremo al più presto poiché la prenotazione sarà in attesa di conferma per i giorni seguenti:",
        roomsToBePaidAtTheHotelDisclaimer: "Questa prenotazione contiene camere a pagare direttamente all´albergo e si debe fornire i dati della carta bancaria per política dell´albergo.",
        paymentRequiredDisclaimer: "Qualcuno del team Love Events ti contatterà a breve per effettuare il pagamento.",
        creditCardInformation: "Informazioni sulla carta di credito",
        creditCardHolder: "Proprietario della carta di credito",
        creditCardNumber: "Numero di carta di credito",
        invalidCreditCardNumber: "Inserisci un numero di carta di credito valido",
        expiration: "Espirazione",
        invalidCreditCardExpiration: "La data di scadenza della carta di credito deve essere successiva alla data della prenotazione",
        invalidCreditCardExpirationActualDate: "La data di scadenza della carta di credito deve essere posteriore alla data effettiva",
        roomDetails: "Detagli camere",
        room: "Camera",
        guests: "Ospiti",
        guestN: "Ospite {{number}}",
        child: "Bambino",
        checkInTime: "Ora di arrivo all´albergo",
        iDontKnow: "Non lo so",
        comments: "Commenti",
        acceptTerms: "Ho letto e accetto ",
        termsAndConditions: "i termini e le condizioni",
        submit: "Finalizza la prenotazione",
        formContainsErrors: "Il modulo contiene errori. Si prega di controllarli.",
        errorWhenMakingTheBookingHeading: "Errore durante la prenotazione",
        errorWhenMakingTheBookingBody: "Si è verificato un errore durante la prenotazione. Per favore riprova. Se il problema persiste, contattaci.",
        prebookingHasExpiredError: "La tua pre-prenotazione è scaduta dopo {{prebookingExpiresIn}} minuti di inattività. Ti preghiamo di avviare nuovamente il processo di prenotazione.",
        bookingDetails: "Dettagli della prenotazione",
        bookingDetailsSubtitle: "Informazioni personali della prenotazione",
        invoiceNameAndSurname: "Nome completo",
        invoicePassportCif: "Numero",
        nationality: "Nazionalità",
        documentType: "Tipo di documento",
        invoiceAddress: "Indirizzo fiscale",
        passport: "Passaporto",
        nie: "NIE",
        dni: "DNI",
        nif: "NIF",
        vat: "VAT",
        other: "Altro",
        invalidDocumentTypeFormat: "Formato {{documentType}} non valido",
        invalidDocumentTypeLetter: "Lettera {{documentType}} non valida",
        invalidNIEFormat: "Formato NIE non valido",
        invalidNIELetter: "Lettera NIE non valida",
        payment: "Pagamento",
        scheduledPaymentDisclaimer: "Verrà effettuato un primo pagamento di {{amount}}. Il {{nextPaymentDate}} il resto dell'importo ({{nextPaymentAmount}}) verrà addebitato automaticamente.",
    },
    bookOk: {
        creditCard: "Pagamento con carta",
        yourBooking: "La tua prenotazione",
        bookingConfirmed: "La tua prenotazione è stata confermata",
        bookingConfirmedAndPaid: "La tua prenotazione è stata confermata e pagata",
        bookingScheduledPayment: "È stato programmato un pagamento di {{nextPaymentAmount}} per il {{nextPaymentDate}}. Una volta effettuato, la sua prenotazione sarà confermata e riceverà un'email di conferma.",
        bookingCanceled: "La tua prenotazione è stata annullata",
        boolingCanceledAndRefunded: "La tua prenotazione è stata annullata e rimborsata",
        roomsWithOverbookingDisclaimer: "Grazie mille per la tua prenotazione. Ti contatteremo il prima possibile, poiché questa prenotazione è in attesa di conferma per i prossimi giorni.",
        statusBookingNotOverbooking: 'Stato della tua prenotazione: Camera riservata e in attesa di pagamento.',
        statusBookingOverbooking: 'Stato della tua prenotazione: Camera bloccata e in attesa di conferma.',
        rememberPayHotel: "Ricorda, quando arrivi in hotel, dovrai pagare ",
        needToPay: "Abbiamo ricevuto la sua prenotazione. Questo hotel richiede il pagamento anticipato.",
        rememberPay: "Abbiamo ricevuto la tua prenotazione. Questo hotel richiede il pagamento anticipato della prenotazione. Puoi effettuare il pagamento ora <PayCometIcon/> oppure un mese prima dell’inizio dell’evento. In tal caso, ti verrà inviato un link per il pagamento via e-mail.",
        selectPaymentMethod: "Seleziona il tuo metodo di pagamento preferito:",
        confirmationNumber: "Numero di conferma",
        nameAndSurnames: "Nome e cognomi",
        email: "E-mail di contatto",
        telephone: "Telefono di contatto",
        hotelDetails: "Dettagli hotel",
        hotelDetailsSubtitle: "Informazioni sull'alloggio prenotato",
        event: "Evento",
        city: "Città",
        hotel: "Albergo",
        address: "Indirizzo",
        payMethod: "Metodo di pagamento",
        payOnHotel: "Paga in hotel",
        roomDetails: "Dettagli camera",
        roomDetailsSubtitle: "Camere incluse nella tua prenotazione",
        roomType: "Tipo di camera",
        occupancy: "Occupazione",
        arrivalHour: "Ora di arrivo",
        guest: "Ospite",
        total: "Totale",
        transferServiceDescription: "Se lo desideri, puoi prenotare un trasporto con noi per completare la tua esperienza.",
        bookTransfer: "Prenota Trasporto",
        totalPending: "Totale da pagare",
        paymentsMade: "Pagamenti effettuati",
        taxesAndFees: "Tasse e costi",
        discount: "Sconto",
        totalBasket: "Totale prenotazione",
        totalPaid: "Totale pagato",
        taxes: "Tasse",
        totalRooms: "Totale alloggio",
        totalRoomsSubtitle: "Importo per il soggiorno e le camere selezionate",
        summaryTitle: "Riepilogo della prenotazione",
        summarySubtitle: "Di seguito puoi vedere il dettaglio degli importi della tua prenotazione.",
        totalPendingSubtitle: "Importo restante da pagare",
        paymentsSubtitle: "Importo già pagato",
        taxesSubtitle: "Tasse applicabili alla tua prenotazione",
        payment: "Pagamento",
        payments: "Pagamenti",
        refund: "Rimborso",
        refunds: "Rimborsi",
        refundsSubtitle: "Importo rimborsato dalla tua prenotazione",
        paymentDateUnknown: "Data sconosciuta",
        paymentMethod: "Metodo",
        paymentDate: "Data",
        noPayments: "Nessun pagamento",
        payWithSelectedCard: "Paga con la carta selezionata",
        processing: "In elaborazione",
        paymentError: "Errore di pagamento. Riprova.",
        payByCard: "Carta",
        payAmount: "Paga {{amount}}",
        payWithLuxon: "Paga {{amount}} con Luxon",
        luxonDescription: "Paga in modo rapido e sicuro con Luxon, il metodo di pagamento per il tempo libero e gli eventi.",
        redirecting: "Reindirizzamento...",
        payNow: "Paga ora",
        payLater: "Paga più tardi",
        schedulePayment: "Programma pagamento",
        schedulePaymentAmount: "Programma pagamento di {{amount}}",
        scheduledPaymentInfoTotalHead: "Oggi verrà effettuata solo una verifica di 0,01 che sarà automaticamente rimborsata.",
        scheduledPaymentInfoTotal: "L'importo totale della prenotazione verrà addebitato automaticamente sulla carta registrata nella data indicata.",
        scheduledPaymentInfoPartialHead: "L'importo che verrà addebitato oggi è un pagamento iniziale per garantire la prenotazione.",
        scheduledPaymentInfoPartial: "L'importo residuo della prenotazione verrà addebitato automaticamente sulla carta registrata nella data indicata.",
        paymentBreakdown: "Dettaglio del pagamento",
        initialPayment: "Pagamento iniziale oggi",
        preauthorization: "Verifica della carta",
        remainingPayment: "Pagamento residuo il {{date}}",
        totalAmount: "Importo totale",
    },
    transfers: {
        fields: {
            transferDetails: "Dettagli Trasferimento",
            personalDetails: "Dettagli Personali",
            passengerName: "Nome",
            passengerLastName: "Cognome",
            passengerContactEmail: "Email",
            passengerPhoneNumber: "Numero di Telefono",
            dialCode: "Codice Paese",
            oneWayTransfer: "Trasferimento Andata",
            returnTransfer: "Trasferimento Ritorno",
            arrivalTransport: "Tipo di Trasporto (Arrivo)",
            arrivalLocationFrom: "Luogo di Arrivo",
            arrivalLocationFromAirplane: "Aeroporto di Arrivo",
            arrivalLocationFromTrain: "Stazione di Arrivo",
            arrivalLocationFromBus: "Stazione di Arrivo",
            arrivalLocationTo: "Punto di Scarico",
            departureTransport: "Tipo di Trasporto (Partenza)",
            departureLocationFrom: "Punto di Prelievo",
            departureLocationToAirplane: "Aeroporto di Partenza",
            departureLocationToTrain: "Stazione di Partenza",
            departureLocationToBus: "Stazione di Partenza",
            departureLocationTo: "Luogo di Destinazione",
            arrivalLocationFromDetails: "Dettagli indirizzo arrivo",
            arrivalLocationToDetails: "Dettagli punto di scarico",
            departureLocationFromDetails: "Dettagli punto di prelievo",
            departureLocationToDetails: "Dettagli luogo destinazione",
            arrivalTransportDate: "Data di Arrivo",
            flightArrivalDate: "Data Arrivo Volo",
            trainArrivalDate: "Data Arrivo Treno",
            busArrivalDate: "Data Arrivo Autobus",
            departureTransportDate: "Data di Partenza",
            flightDepartureDate: "Data Partenza Volo",
            trainDepartureDate: "Data Partenza Treno",
            busDepartureDate: "Data Partenza Autobus",
            arrivalTransportTime: "Ora di Arrivo",
            flightArrivalTime: "Ora Arrivo Volo",
            trainArrivalTime: "Ora Arrivo Treno",
            busArrivalTime: "Ora Arrivo Autobus",
            departureTransportTime: "Ora di Partenza",
            flightDepartureTime: "Ora Partenza Volo",
            trainDepartureTime: "Ora Partenza Treno",
            busDepartureTime: "Ora Partenza Autobus",
            arrivalNumberOfPassengers: "Numero di Passeggeri (Arrivo)",
            departureNumberOfPassengers: "Numero di Passeggeri (Partenza)",
            pickUpTime: "Ora di Prelievo",
            pickUpTimeHelper: "Per garantire un'esperienza di partenza senza problemi, consigliamo di selezionare un'ora di prelievo che consenta almeno 2 ore prima del volo, più il tempo di viaggio verso l'aeroporto",
            airline: "Compagnia Aerea",
            flightNumber: "Numero Volo",
            trainCompany: "Compagnia Ferroviaria",
            trainNumber: "Numero Treno",
            busCompany: "Compagnia di Autobus",
            busNumber: "Numero Autobus",
            transportReference: "Riferimento Trasporto",
            transportReferenceNumber: "Numero Riferimento Trasporto",
            comments: "Commenti",
            sedan: "Sedan",
            van: "Van",
            businessSedan: "Business Sedan",
            businessVan: "Business Van",
            maxPassengers: "Massimo passeggeri",
            direction: "Direzione",
            status: "Stato",
            price: "Prezzo",
            confirmationNumber: "Numero di conferma",
            vehicle: "Veicolo",
            luggageCapacity: "Capacità bagagli",
            termsAndConditions: 'Termini e Condizioni del Trasferimento',
            termsAndConditionsInfo: {
                cancellation: 'Politica di cancellazione: I trasferimenti aeroportuali non possono essere cancellati gratuitamente entro 24 ore dall\'orario di ritiro previsto. Le cancellazioni effettuate meno di 24 ore prima del trasferimento non sono rimborsabili.',
                missedFlights: 'Voli persi: Se perdi il tuo volo e hai bisogno di un nuovo trasferimento, questo sarà considerato come una nuova prenotazione e addebitato di conseguenza.',
                flightDelays: 'Ritardi dei voli: Se il tuo volo è in ritardo, non preoccuparti, il tuo autista monitorerà il tuo volo e regolerà l\'orario di ritiro in base all\'orario effettivo di arrivo del volo.',
            },
        },
        message: {
            typeOfTransfer: "Tipo di Trasferimento",
            formTitle: "Richiesta di Trasferimento",
            transferDetailsSent: "I dettagli del trasferimento sono stati inviati a {{email}}",
            succesCreatingRequestTransfer: "La tua richiesta di trasferimento è stata inviata con successo. ",
            newTransferRequest: "Richiedi un nuovo trasferimento",
            confirmationShortly: "Verificheremo tutti i dettagli e ti invieremo un'email di conferma a breve.",
            paymentEmailNotice: "Presto riceverai un'email con un link di pagamento. Una volta completato il pagamento, confermeremo il tuo trasferimento.",
            anyChanges: "Per qualsiasi modifica, contatta: {{email}}.",
            mustReadTerm: "Devi accettare i termini e le condizioni",
            noVehiclesAvailable: "Nessun veicolo disponibile",
            termsLinkMessage: "Accetto i",
            termsTitle: "Termini e Condizioni",
            footerDescription2: "Riceverai una conferma della tua richiesta a {{customerEmail}}",
            comments: "Commenti",
            selectTransportFirst: "Seleziona un trasporto prima",
            selectArrivalLocationFromFirst: "Seleziona prima una località di arrivo",
            selectDepartureLocationFromFirst: "Seleziona prima una località di prelievo",
            enterAddressDetails: "Per favore inserisci l'indirizzo dettagliato (strada, edificio, numero appartamento, ecc.)",
            selectVehicleArrival: "Seleziona il tuo veicolo di arrivo",
            selectVehicleDeparture: "Seleziona il tuo veicolo di partenza",
            customRoute: "Esamineremo il costo di questo percorso personalizzato per te e ti invieremo il prezzo via email entro 24 ore",
            noTransfers: "Non hai ancora nessun trasferimento.",
            toConfirm: "Per confermare"
        },
    },
    transferSearch: {
        fields: {
            city: "Città",
        },
        message: {
            searchByDirection: "Cerca per direzione",
            searchByTransferStatus: "Cerca per stato del trasferimento",
            searchByConfirmationNumber: "Cerca per numero di conferma",
            searchByEvent: "Cerca per evento",
            searchByHotel: "Cerca per albergo",
            searchByYear: "Cerca per anno",
            searchByCity: "Cerca per città",
        }
    },
    transferOk: {
        fields: {
            nameAndSurnames: "Nome e Cognome",
            event: "Evento",
            totalTransfer: "Totale Trasferimento",
            totalTransferSubtitle: "Importo totale del trasferimento prenotato",
            totalToPay: "Totale da pagare",
            totalPaid: "Totale pagato",
            numberOfPassengers: "Numero di passeggeri",
            locationFrom: "Da",
            locationTo: "A",
            person: "persona",
            persons: "persone",
            arrivalInstructions: "Istruzioni di Arrivo",
            departureInstructions: "Istruzioni di Partenza"
        },
        message: {
            yourTransfer: "La tua prenotazione del trasferimento",
            transferConfirmed: "Il tuo trasferimento è stato confermato.",
            transferConfirmedAndPaid: "Il tuo trasferimento è stato confermato e pagato.",
            transferPaymentRequested: "Il pagamento del tuo trasferimento è stato richiesto. Non appena riceveremo il pagamento, il tuo trasferimento sarà confermato e riceverai un'email di conferma.",
            transferPending: "Il tuo trasferimento è in attesa di conferma.",
            transferCanceled: "Il tuo trasferimento è stato annullato.",
            transferCanceledAndRefunded: "Il tuo trasferimento è stato annullato e rimborsato.",
            transferDetails: "Dettagli del trasferimento",
            personalDetails: "Dati personali",
            eventDetails: "Dettagli dell'evento",
            bookAnotherTransfer: "Prenota un altro trasferimento",
            sharedWithPassenger: "Condiviso con",
            flightDetails: "Dettagli del volo",
            trainDetails: "Dettagli del treno",
            busDetails: "Dettagli dell'autobus",
            transportDetails: "Dettagli del trasporto",
            personalDetailsSubtitle: "Informazioni personali sul tuo trasferimento",
            eventDetailsSubtitle: "Informazioni sull'evento del tuo trasferimento",
            transportDetailsSubtitle: "Informazioni sul trasporto",
            transferDetailsSubtitle: "Informazioni sul trasferimento",
        }
    },
    terms: {
        labels: {
            readCompleteDocument: "Leggi il documento completo.",
            revised: "visionato",
            scrollToTheEnd: "Scorri fino alla fine",
            documentRevised: "Documento visionato",
            mustReadAllDocument: "Devi leggere l’intero documento prima di accettarlo.",
        }
    },
    paymentCard: {
        saveCard: "Salva carta",
        cardSavedSuccess: "La tua carta è stata salvata con successo",
        noSavedCards: "Non hai carte salvate",
        selectCard: "Seleziona carta di pagamento",
        addCard: "Aggiungi nuova carta",
        cancelAddCard: "Annulla",
        saveAndSelect: "Salva e seleziona",
        mustSelectCard: "Devi selezionare una carta per continuare",
        changeCard: "Cambia carta",
        cardAdded: "Carta aggiunta",
        securePayment: "Pagamento sicuro con crittografia SSL",
        primary: 'Primaria',
        isPrimary: "Scheda principale",
        setPrimary: 'Imposta come scheda principale',
    },
    packages: {
        fields: {
            selectARoom: 'Seleziona una camera',
            selectRoom: 'Seleziona Camera',
            addMoreRooms: 'Aggiungi altre camere',
            completePersonalDetails: 'Completa i dati personali',
            completeTransferDetails: 'Completa i dettagli del trasferimento',
            personalDetails: 'Dati Personali',
            personalDetailsDescription: 'Completa i tuoi dati personali per finalizzare la prenotazione',
            addAnotherTransfer: 'Aggiungi un altro trasferimento',
        },
        message: {
            winnerPackageNoticeBanner: "Congratulazioni per aver vinto un pacchetto per {{cityEvent}} dal {{startDate}} al {{endDate}}.",
            packageIncludedOneTransfer: "Congratulazioni, il tuo pacchetto include un trasferimento gratuito all'arrivo o alla partenza. Completa i dettagli per continuare.",
            packageIncludedNoTransfer: "Congratulazioni, il tuo pacchetto non include trasferimenti. Completa i tuoi dati personali per finalizzare la prenotazione.",
            confirmAccommodationDates: "Conferma le date dell'alloggio",
            canCheckInEarlierOrCheckOutLater: 'Se necessario, puoi arrivare prima o partire dopo le date del tuo alloggio.',
            canBookAnotherTransfer: 'Se necessario, puoi prenotare un altro trasferimento con noi, ma questo dovrà essere pagato.',
            optionalTransferAllOrNothing: 'Hai iniziato a compilare il trasferimento aggiuntivo. Completa tutti i campi o lascialo vuoto per continuare.',
        },
        validation: {
            selectRoomDescription: "Seleziona una camera per continuare",
            addMoreIfYouNeed: "Se desideri aggiungere altre camere rispetto a quella che hai già vinto, selezionale. Altrimenti, continua.",
            completePersonalDetails: "Completa i dati personali per continuare",
            roomRequired: "Devi selezionare una camera",
            personalDetailsRequired: "Devi completare i tuoi dati personali",
            datesRequired: "Devi selezionare le date dell'alloggio",
            startDateTooEarly: "La data di inizio non può essere precedente a {{minStartDate}}",
            endDateTooLate: "La data di fine non può essere successiva a {{maxEndDate}}",
            invalidDateRange: "La data di inizio deve essere precedente alla data di fine",
            startDateOutOfRange: "La data di inizio deve essere tra {{minDate}} e {{maxDate}}",
            endDateOutOfRange: "La data di fine deve essere tra {{minDate}} e {{maxDate}}",
            startDateBeforeEvent: "La data di inizio non può essere precedente alla data di inizio dell'evento ({{eventStartDate}})",
            endDateAfterEvent: "La data di fine non può essere successiva alla data di fine dell'evento ({{eventEndDate}})",
        }
    },
};

export default translations;
